module.exports = __webpack_public_path__ + "static/media/IMG_7236.313895ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/horizontal/IMG_7236.jpg
// module id = 148
// module chunks = 0